import React, { createContext, useContext, useEffect, useState } from "react";

const DomainContext = createContext<string>("");

export const DomainProvider = ({ children }: { children: React.ReactNode }) => {
  const [domain, setDomain] = useState<string>("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setDomain(window.location.origin);
    }
  }, []);

  return (
    <DomainContext.Provider value={domain}>{children}</DomainContext.Provider>
  );
};

export const useDomain = () => useContext(DomainContext);
